import { motion } from "framer-motion";
import { SERVICES } from "@/lib/site-data";

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Services() {
  return (
    <section id="services" className="bg-secondary text-secondary-foreground py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-14"
        >
          <span className="text-xs uppercase tracking-[0.3em] text-primary font-medium">
            One Unified Platform
          </span>
          <h2 className="font-display text-4xl md:text-6xl mt-4 leading-[1.02] text-white">
            Intelligent solutions for every stage.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 auto-rows-[220px] gap-5">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`service-card-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] hover:bg-white/[0.07] p-7 flex flex-col justify-between transition-[background-color,transform] duration-500 hover:-translate-y-1 ${s.span}`}
            >
              {s.image && (
                <div className="absolute inset-0 -z-0">
                  <img src={s.image} alt="" className="h-full w-full object-cover opacity-25 group-hover:opacity-35 transition-opacity duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/70 to-transparent" />
                </div>
              )}
              <div className="relative z-10">
                <span className="inline-block text-[10px] uppercase tracking-[0.2em] text-primary border border-primary/40 rounded-full px-3 py-1">
                  {s.tag}
                </span>
              </div>
              <div className="relative z-10">
                <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">
                  {s.title}
                </h3>
                <p className="text-sm text-white/70 mt-2 max-w-md leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
